import React, {useEffect, useState} from "react";
import style from './TopLogin.scss';
import {ifLoginDo, keepLoginKey, login, logout, rememberIdKey, rememberIdMailKey} from "@/util/authentication";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";
import {Logo} from "@/components/atom/Logo";
import LoginLayout from "@/layout/LoginLayout";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCaretRight} from "@fortawesome/free-solid-svg-icons";
import CandMInformation from "@/components/CandMInformation";
import {getFromStorage, storeToStorage} from "@/store/storage";
import {getRedirect, removeRedirect} from "@/util/redirection";

const Login = () => {
  const history = useHistory()
  const [mail, setMail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberId, setRememberId] = useState(false)
  const [keepLogin, setKeepLogin] = useState(false)

  useEffect(() => {
  }, [])
  useEffect(() => {
    (async () => {
      await ifLoginDo(() => {
        history.push(`/menu`)
      })
      const keepLogin = getFromStorage(keepLoginKey, false)
      setKeepLogin(keepLogin)
      const rememberId = getFromStorage(rememberIdKey, false)
      setRememberId(rememberId)
      if (rememberId) {
        const mail = getFromStorage(rememberIdMailKey)
        setMail(mail)
      }
    })()
  }, [])

  const handleLogin = async (e) => {
    logout()
    const successLogin = await login({ mail, password})
    if (successLogin) {
      storeToStorage(rememberIdKey, rememberId)
      storeToStorage(keepLoginKey, keepLogin)
      if (rememberId) {
        storeToStorage(rememberIdMailKey, mail)
      }
      const redirect = getRedirect()
      if (redirect !== '') {
        removeRedirect()
        history.push(redirect)
      } else {
        history.push('/menu')
      }
    }
  }
  const toResetPassword = () => {
    history.push('/password')
  }

  const canLogin = () => {
    return mail !== '' && password !== ''
  }

  const toRegister = () => {
    history.push('/register/propose')
  }

  return (
    <div className="App">
      <LoginLayout category={''}>
        <div className={style.loginTop}>
          <div className={style.contents}>
            <div className={`${style.cmLogo} ${style.titleLogoBlock}`}>
              <img src={'/candm_l.png'}/>
            </div>
            <div>
              <div className={`${style.mainTitle} ${style.titleLogoBlock}`}>
                <Logo/>
              </div>
              <div className={style.loginForm}>
                <div className={style.loginTitleLine}>
                  <span className={style.loginTitle}>ID(メールアドレス) ※半角英数</span>
                  <input type="text" value={mail} onChange={(e) => setMail(e.target.value)}/>
                  <div className={style.loginFooter}>
                    <label>
                      <input className={style.loginCheck} type={'checkbox'} checked={rememberId} onChange={() => {setRememberId(!rememberId)}} />
                      <span>次回からIDの入力を省略</span>
                    </label>
                  </div>
                </div>
                <div className={style.loginTitleLine}>
                  <span className={style.loginTitle}>パスワード ※半角英数8文字以上</span>
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                  <div className={style.loginFooter}>
                    <label>
                      <input className={style.loginCheck} type={'checkbox'} checked={keepLogin} onChange={() => { setKeepLogin(!keepLogin) }} />
                      <span>ログイン状態を保存</span>
                    </label>
                  </div>
                </div>
                <div>
                  <MButton value={'ログイン'} width={180} onClick={handleLogin} disabled={!canLogin()} color={'#4B74B5'} ></MButton>
                </div>
              </div>
              <div className={style.passwordInformationBox}>
                <div className={style.passwordInformation}>
                  <FontAwesomeIcon icon={faCaretRight}/>パスワードをお忘れの方は
                  <span onClick={toResetPassword} className={style.link}>コチラ</span>
                </div>
              </div>
              <div className={style.registerInformation}>
                <div>
                  <div>
                    <span className={style.registerInformationText}>名刺Rを利用・閲覧するにはIDの登録が必要です</span>
                  </div>
                  <MButton value={'新規登録（無料）'} width={180} onClick={toRegister} color={'#4B74B5'} ></MButton>
                </div>
              </div>
            </div>
          </div>
          <CandMInformation/>
        </div>
      </LoginLayout>
    </div>
  )
}

export default Login;
